import { discoveryState } from "./ingestion";
export const CHANNELS = [
    { key: "ads", title: "Ads", description: "The first impression", label: "advertisements" },
    { key: "entry_points", title: "Entry Points", description: "Where interest begins", label: "entry points" },
    { key: "offer_pages", title: "Offer Pages", description: "Where the offer comes together", label: "offer pages" },
    { key: "email_sms", title: "Email / SMS", description: "The conversation continues", label: "messages" },
];
export const safeUrl = value => { try {
    const u = new URL(value);
    return ["https:", "http:"].includes(u.protocol) && !u.username && !u.password ? value : null;
}
catch {
    return null;
} };
export const money = (value, currency) => value == null || !currency || !Number.isFinite(Number(value)) ? "—" : new Intl.NumberFormat("en-US", { style: "currency", currency }).format(value / 100);
export const number = value => value == null || !Number.isFinite(Number(value)) ? "—" : new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(value);
export const percent = value => value == null ? "—" : `${number(value * 100)}%`;
export const date = value => value && Number.isFinite(Date.parse(value)) ? new Date(value).toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }) : "Not observed yet";
export const offerLabel = (offer, ingestion, pageJob) => offer.origin === "manual_confirmed" ? "Confirmed offer" : offer.origin === "manual_draft" ? `Draft · ${discoveryState(offer, ingestion, pageJob).label}` : "Observed offer";
export const activeJobs = ingestion => ingestion?.enabled === true && (ingestion?.jobs || []).some(job => ["queued", "running", "retryable", "failed"].includes(job.status));
export function cents(value) {
    if (!/^\d{1,13}(\.\d{1,2})?$/.test(String(value)))
        throw new Error("Enter a valid price with up to two decimal places.");
    const [whole, fraction = ""] = String(value).split(".");
    const result = Number(whole) * 100 + Number(fraction.padEnd(2, "0"));
    if (!Number.isSafeInteger(result) || result > 999999999999999)
        throw new Error("This price is too large.");
    return result;
}
export function buildOfferInput(form) {
    const name = form.name.trim(), currency = form.currency.toUpperCase();
    if (!name || name.length > 200)
        throw new Error("Add an offer name of 200 characters or fewer.");
    if (!/^[A-Z]{3}$/.test(currency))
        throw new Error("Choose a three-letter currency code.");
    if (form.path === "url") {
        if (!safeUrl(form.pageUrl) || new URL(form.pageUrl).hash)
            throw new Error("Enter a complete http:// or https:// page URL without a fragment.");
        return { name, currency, pageUrl: form.pageUrl.trim(), products: [] };
    }
    if (!form.products.length)
        throw new Error("Choose at least one Shopify product.");
    if (form.products.some(p => !Number.isInteger(p.quantity) || p.quantity < 1 || p.quantity > 999999))
        throw new Error("Product quantities must be positive whole numbers.");
    const pricing = { type: form.billing, initialPriceCents: cents(form.initial) };
    if (form.billing === "subscription") {
        if (!Number.isInteger(Number(form.intervalCount)) || Number(form.intervalCount) < 1 || Number(form.intervalCount) > 120)
            throw new Error("Renewal frequency must be between 1 and 120.");
        Object.assign(pricing, { renewalPriceCents: cents(form.renewal), intervalCount: Number(form.intervalCount), intervalUnit: form.intervalUnit });
    }
    return { name, currency, products: form.products.map(({ productKey, variantKey, quantity }) => ({ productKey, ...(variantKey ? { variantKey } : {}), quantity })), pricing };
}
export function metricFields(asset) {
    const m = asset.metrics || {};
    if (m.metricBasis === "landing_session")
        return [["sessions", "Sessions"], ["addToCartSessions", "Cart sessions"], ["checkoutSessions", "Checkout sessions"], ["completedCheckoutSessions", "Completed checkout sessions"], ["conversionRate", "Session conversion rate", "percent"]];
    if (asset.kind === "message")
        return [["delivered", "Delivered"], ["clickRate", "Click rate", "percent"], ["clicks", "Clicks"], ["conversions", "Conversions"], ["revenueCents", "Revenue", "money"]];
    if (asset.role === "entry_point")
        return [["views", "Views"], ["clicks", "Click-throughs"], ["ctr", "Click-through rate", "percent"]];
    if (asset.kind === "page")
        return [["views", "Views"], ["conversionRate", "Conversion rate", "percent"], ["addToCarts", "Add to carts"], ["checkouts", "Checkouts"]];
    return [["spendCents", "Spend", "money"], ["roas", "ROAS", "ratio"], ["cpaCents", "CPA", "money"], ["views", "Views"], ["clicks", "Clicks"], ["conversions", "Conversions"], ["revenueCents", "Revenue", "money"], ["impressions", "Impressions"]];
}
export const metricValue = (metrics, key, format) => format === "money" ? money(metrics[key], metrics.currency) : format === "percent" ? percent(metrics[key]) : format === "ratio" ? metrics[key] == null ? "—" : `${number(metrics[key])}×` : number(metrics[key]);
export const productUnavailable = product => ["absent", "unresolved"].includes(product.availability) || product.status === "unavailable";
